import React,{Component} from "react";
import "./milestone.css";
import Translation from '../../common/translation/translation.component';
import Icons from "../../icon";
import { DISMISSAL_STATUSES, TYPE_FUNCTION } from "../../../constants/external-constants";
import { convertToFormatDate } from "../../../utils/helpers.utils";
export class Milestone extends Component {


    getIconName = (milestone, index, activeIndex, icon, isDismissed) => {
        if (typeof milestone?.status === 'string' && isDismissed) return "xmark";
        if (index <= activeIndex) return "check";
        return icon;
    }

    getClassName = (milestone, index, milestonesLength, activeIndex, icon, isDismissed) => {
        const classNames = ["icon-circle-container"];
    
        if (isDismissed) classNames.push("reject");
        if (icon) classNames.push(`icon-${icon}-wrapper`);
        if (this.props.isReadAndWrite && index === activeIndex + 1) classNames.push('next-container');
        if (index < activeIndex) classNames.push('previousMilestone');
        if (index === activeIndex || index < activeIndex) classNames.push('activeMilestone');
        if (index !== milestonesLength - 1) classNames.push('has-line');
    
        return classNames.join(" ");
    }
    
    
    milestoneContent = (milestone, index, handleMilestoneClick) => {
        const { milestones, activeIndex, icon, allowAllClickableIcon, enableHover, onSelectedMilestone, hoverMessage, dateFormat = `MMMM DD, YYYY` } = this.props;
        const isDismissed = DISMISSAL_STATUSES.some(status => status.label === milestone?.status);
        const iconName = this.getIconName(milestone, index, activeIndex, icon, isDismissed);
        const className = this.getClassName(milestone, index, milestones.length, activeIndex, icon, isDismissed);
    
        return (
            <div key={index} className={className}>
                {icon ? (
                    <>
                        <Icons
                            customClassName={`icon-${icon}`}
                            name={iconName}
                            size="20px"
                            containerClass={`icon-${icon}-container ${isDismissed ? "rejected" : ""}`}
                            onClick={(index === activeIndex || index < activeIndex || allowAllClickableIcon) ? ()=>{handleMilestoneClick(index)}  
                            : this.props.isReadAndWrite? (index <= activeIndex || index === activeIndex + 1 )? ()=>{handleMilestoneClick(index)} 
                            : undefined : 
                            undefined} 
                        />
                        {enableHover && (
                            <div className={`milestone__hover ${onSelectedMilestone === index ? 'show-section' : null}`}>
                                {hoverMessage}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="icon-circle">
                        {index + 1}
                    </div>
                )}
                {typeof milestone === 'string' ? (
                    <span><Translation translationKey={milestone} /></span>
                ) : (
                    <>
                        <span><Translation translationKey={milestone?.label} /></span>
                            <span className="sub-label">{milestone?.date && `${milestone.status.charAt(0).toUpperCase() + milestone.status.slice(1)} on `}
                                <br /> {milestone?.date && ` ${convertToFormatDate(milestone?.date, dateFormat)}`}
                            </span>
                    </>
                )}
            </div>
        );
    }

    render(){
        const {milestones, milestonesLabel, containerClass, refNode}=this.props
        const handleMilestoneClick= (index)=>{
            if (typeof this.props.handleAction === TYPE_FUNCTION) {
                this.props.handleAction(index)
            }           
        }

        return(
            <div className={`milestone-wrapper ${containerClass} `}>
                {
                    milestonesLabel &&
                    <span className="milestone-label"><Translation translationKey={milestonesLabel} /></span>
                }                 
                <div ref={refNode} className="milestone-container">               
                    {(milestones && this.props.milestones.length > 0) && milestones.map((milestone, index) => (
                        this.milestoneContent(milestone, index, handleMilestoneClick)
                    ))}
                </div>
            </div>
        )
    }
}